import Item from "./item";


//Отображение списка сообщений
export default function Pull({list, setCount}) {
	return list.map((el, i) => <Item key={i} value={el.value} date={el.date} end={list.length === i+1}/>)
}